import { Ref, ref, watch } from 'vue'
import { History } from '@/utils/history'
import { nodeList } from '@/utils/answer'
import { assertNaN, getUrlParams } from '@/utils/tools'
import { useRoute } from 'vue-router'
import { Timer } from '@/utils/questionnaireTimer'
import { MemoryStorage } from '@/utils/MemoryStorage'
const storage = MemoryStorage.getInstance()
export function useCache(conf_id: Ref<string>) {
  const parmas = getUrlParams()
  const userid = parmas.user_id || parmas.userid || -1
  const currentIndex = ref(0)
  const surveyId = ref<string>()
  const nodes: number[] = []
  const history = new History()
  const route = useRoute()
  watch(currentIndex, () => {
    if (route.name === 'Preview') {
      return
    }
    if (conf_id.value) {
      storage.setItem(
        `survey_${userid}_${conf_id.value}`,
        JSON.stringify({
          c: currentIndex.value,
          n: nodes,
          s: history.showList,
          h: history.hideList,
          t: nodeList.head,
          w: nodeList.tail,
        })
      )
    }
  })

  watch(
    conf_id,
    () => {
      if (route.name === 'Preview') {
        return
      }
      if (conf_id.value) {
        Timer.initTime(`survey_${userid}_${conf_id.value}_timer`)
        const data = storage.getItem(`survey_${userid}_${conf_id.value}`)
        if (!data) return
        try {
          const json = JSON.parse(data)
          currentIndex.value = assertNaN(Number(json.c)) ? 0 : Number(json.c)
          nodes.splice(0, nodes.length, ...json.n)
          history.showList.splice(0, history.showList.length, ...json.s)
          history.hideList.splice(0, history.hideList.length, ...json.h)
          let node = json.t
          while (node) {
            nodeList.append(node.value)
            node = node.next
          }
          // nodeList.head = json.t
          // nodeList.tail = json.w
        } catch (error) {
          console.error(error)
        }
      }
    },
    {
      immediate: true,
    }
  )

  return {
    currentIndex,
    surveyId,
    nodes,
    history,
    clear: () => {
      Timer.initTime(`survey_${userid}_${conf_id.value}_timer`)
      Timer.clearTime(`survey_${userid}_${conf_id.value}_timer`)
      storage.removeItem(`survey_${userid}_${conf_id.value}`)
    },
  }
}
